import Rules, { ValidateRule } from '@lsfe/rules';
import { unitEnum } from 'utils/enum';

function getDecimalLen(num) {
    if (!num) return 0;
    const decimalStr = num.toString().split('.')[1] || '';
    return decimalStr.length;
}
// 销售单位是kg时，购买步长，每单限购数，最小购买数 最多三位小数
function genSellUnitEqualKgValidRule() {
    return new ValidateRule({
        validator(rule, value, cb, data) {
            const sellUnitIsKg = +data.sellUnitId === unitEnum.KILOGRAM_UNIT_ID;
            const decimalLen = getDecimalLen(value);
            if (sellUnitIsKg) {
                if (decimalLen > 3) {
                    cb(new Error('最多三位小数'));
                } else {
                    cb();
                }
            } else {
                if (decimalLen > 0) {
                    cb(new Error('填写整数'));
                } else {
                    cb();
                }
            }
        },
    });
}

// eslint-disable-next-line import/prefer-default-export
export function getRules() {
    return Object.freeze({
        supplierId: [
            Rules.isRequired('供应商必填'),
        ],
        manufacturerId: [
            Rules.isRequired('生产商必填'),
            Rules.range({ min: 1 }, '生产商必填'),
        ],
        rdcIdList: [
            Rules.isRequired('仓必填'),
        ],
        purchasePrice: [
            Rules.isRequired('城市采购价必填'),
            Rules.decimalLen({ len: 4 }, '最多4位小数'),
            Rules.range({
                min: 0,
                max: 9999,
                le: false,
                ge: false,
            }, '0< 当前值 <9999'),
        ],
        sellPrice: [
            // Rules.isRequired('城市售价必填'),
            Rules.decimalLen({ len: 2 }, '最多2位小数'),
            Rules.range({
                min: 0,
                max: 15000,
                le: false,
                ge: false,
            }, '0< 当前值 <15000'),
        ],
        shippingType: [
            Rules.isRequired('配送方式必选'),
        ],
        replenishStep: [
            // Rules.isRequired('补货步长必填'),
            Rules.decimalLen({ len: 0 }, '填写整数'),
            Rules.range({
                min: 0,
                max: 9999,
                le: false,
                ge: false,
            }, '0< 当前值 <9999'),
        ],
        detachFlag: [
            Rules.isRequired('是否可拆零必填'),
        ],
        addSpan: [
            Rules.isRequired('购买步长必填'),
            Rules.range({
                min: 0,
                max: 9999,
                le: false,
                ge: true,
            }, '0< 当前值 <=9999'),
            genSellUnitEqualKgValidRule(),
        ],
        sellUnitRelationQuantity: [
            Rules.decimalLen({ len: 0 }, '填写整数'),
            Rules.range({
                min: 0,
                le: true,
            }, '大于等于0'),
        ],
        orderMin: [
            Rules.isRequired('最小购买数必填'),
            Rules.range({
                min: 0,
                max: 9999,
                le: false,
                ge: true,
            }, '0< 当前值 <=9999'),
            genSellUnitEqualKgValidRule(),
        ],
        orderMax: [
            // Rules.isRequired('每单限购数必填'),
            Rules.range({
                min: 0,
                max: 9999,
                le: false,
                ge: true,
            }, '0< 当前值 <=9999'),
            genSellUnitEqualKgValidRule(),
        ],
        sourceChannels: [
            Rules.isRequired('请选择'),
            Rules.lenRange({ min: 1 }, '请至少填一个'),
        ],
        deliveryFloatLess: [
            Rules.decimalLen({ len: 3 }, '最多3位小数'),
            new ValidateRule({
                validator(rule, value, cb, data) {
                    if (+value >= 0 && value <= +data.addSpan) {
                        cb();
                    } else {
                        cb(new Error('0<= 当前值 <= 购买步长'));
                    }
                },
            }),
        ],
        deliveryFloatMore: [
            Rules.decimalLen({ len: 3 }, '最多3位小数'),
            new ValidateRule({
                validator(rule, value, cb, data) {
                    if (+value >= 0 && value <= +data.addSpan) {
                        cb();
                    } else {
                        cb(new Error('0<= 当前值 <= 购买步长'));
                    }
                },
            }),
        ],
        sellPurposeType: [
            Rules.isRequired('售卖类型必选'),
            // Rules.notZero('请选择具体的售卖类型'), // 字典中取消了0
        ],
        seasonalSale: [
            Rules.isRequired('是否应季品必选'),
        ],
    });
}
